import 'frappe/public/js/frappe/form/controls/base_control';
import 'frappe/public/js/frappe/form/controls/base_input';
import 'frappe/public/js/frappe/form/controls/data';
import 'frappe/public/js/frappe/form/controls/int';
import './int_extend';
import 'frappe/public/js/frappe/form/controls/float';
import 'frappe/public/js/frappe/form/controls/currency';
import 'frappe/public/js/frappe/form/controls/date';
import 'frappe/public/js/frappe/form/controls/time';
import 'frappe/public/js/frappe/form/controls/datetime';
import 'frappe/public/js/frappe/form/controls/date_range';
import 'frappe/public/js/frappe/form/controls/select';
import 'frappe/public/js/frappe/form/controls/link';
import 'frappe/public/js/frappe/form/controls/dynamic_link';
import 'frappe/public/js/frappe/form/controls/text';
import 'frappe/public/js/frappe/form/controls/code';
import 'frappe/public/js/frappe/form/controls/text_editor';
import 'frappe/public/js/frappe/form/controls/comment';
import 'frappe/public/js/frappe/form/controls/check';
import 'frappe/public/js/frappe/form/controls/image';
import 'frappe/public/js/frappe/form/controls/attach';
import 'frappe/public/js/frappe/form/controls/attach_image';
import 'frappe/public/js/frappe/form/controls/table';
import 'frappe/public/js/frappe/form/controls/color';
import 'frappe/public/js/frappe/form/controls/signature';
import 'frappe/public/js/frappe/form/controls/password';
import 'frappe/public/js/frappe/form/controls/read_only';
import 'frappe/public/js/frappe/form/controls/button';
import 'frappe/public/js/frappe/form/controls/html';
import 'frappe/public/js/frappe/form/controls/markdown_editor';
import 'frappe/public/js/frappe/form/controls/html_editor';
import 'frappe/public/js/frappe/form/controls/heading';
import 'frappe/public/js/frappe/form/controls/autocomplete';
import 'frappe/public/js/frappe/form/controls/barcode';
import 'frappe/public/js/frappe/form/controls/geolocation';
import 'frappe/public/js/frappe/form/controls/multiselect';
import 'frappe/public/js/frappe/form/controls/multicheck';
import 'frappe/public/js/frappe/form/controls/table_multiselect';
import 'frappe/public/js/frappe/form/controls/multiselect_pills';
import 'frappe/public/js/frappe/form/controls/multiselect_list';
import 'frappe/public/js/frappe/form/controls/rating';
import 'frappe/public/js/frappe/form/controls/duration';
import 'frappe/public/js/frappe/form/controls/icon';


frappe.ui.form.make_control = function (opts) {
	var control_class_name = "Control" + opts.df.fieldtype.replace(/ /g, "");
	if(frappe.ui.form[control_class_name]) {
		return new frappe.ui.form[control_class_name](opts);
	} else {
		// eslint-disable-next-line
		console.log("Invalid Control Name: " + opts.df.fieldtype);
	}
};